/* 
* ACCORDION BLOCK
*/

// Function to check if any accordion is open
function updateAccordionToggleButton(button, accordions) {
    const anyOpen = Array.from(accordions).some(accordion => accordion.classList.contains('show'));
    
    // Update button text based on open state
    button.innerHTML = anyOpen
        ? '<i class="me-1 fa-sharp fa-regular fa-square-minus"></i> Collapse All' 
        : '<i class="me-1 fa-sharp fa-regular fa-square-plus"></i> Expand All';
}

// Function to initialize collapse behavior
function handleAccordionToggle(button, accordions, isExpandAll) {
    accordions.forEach(accordion => {
        let bsCollapse = bootstrap.Collapse.getInstance(accordion);
        
        // Initialize the collapse instance if it doesn't exist
        if (!bsCollapse) {
            bsCollapse = new bootstrap.Collapse(accordion, {
                toggle: false // Initialize without toggling
            });
        }

        // Expand or collapse based on button state
        isExpandAll ? bsCollapse.show() : bsCollapse.hide();
    });
}

// Function to update aria-expanded and button classes
function updateButtonStates(accordionButtons, isExpandAll) {
    accordionButtons.forEach(button => {
        button.setAttribute('aria-expanded', isExpandAll ? 'true' : 'false');
        button.classList.toggle('collapsed', !isExpandAll); // Toggle collapsed class
    });
}

// Update individual accordion button states
function updateIndividualButtonState(accordionButton, isExpanded) {
    accordionButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    accordionButton.classList.toggle('collapsed', !isExpanded); // Toggle collapsed class
}

// Show / Hide all accordion sections
document.querySelectorAll('.btn-toggleAccordion').forEach(button => {
    const accordionId = button.getAttribute('data-accordion-id');
    const accordions = document.querySelectorAll(`#${accordionId} .accordion-collapse`);
    const accordionButtons = document.querySelectorAll(`#${accordionId} .accordion-button`);
    
    button.addEventListener('click', function() {
        // Check if the button currently says "Expand All"
        const isExpandAll = this.innerHTML.includes('Expand All');
        
        // Expand/collapse all accordions
        handleAccordionToggle(button, accordions, isExpandAll);
        
        // Update aria-expanded and collapsed class for buttons
        updateButtonStates(accordionButtons, isExpandAll);

        // Update the button text based on the action
        updateAccordionToggleButton(this, accordions);
    });
});

// Listen to individual accordion item changes using Bootstrap collapse events
document.querySelectorAll('.accordion-collapse').forEach(accordion => {
    const accordionId = accordion.closest('.accordion').getAttribute('id');
    const toggleButton = document.querySelector(`[data-accordion-id="${accordionId}"]`);
    const accordions = document.querySelectorAll(`#${accordionId} .accordion-collapse`);

    const accordionButton = accordion.closest('.accordion-item').querySelector('.accordion-button');

    // Update arrow before the accordion starts expanding
    accordion.addEventListener('show.bs.collapse', function () {
        updateIndividualButtonState(accordionButton, true); // Update arrow direction for this button
    });

    // When an accordion item is shown (expanded), update button state
    accordion.addEventListener('shown.bs.collapse', function () {
        updateAccordionToggleButton(toggleButton, accordions); // Update "Collapse All" button
    });

    // Update arrow before the accordion starts collapsing
    accordion.addEventListener('hide.bs.collapse', function () {
        updateIndividualButtonState(accordionButton, false); // Update arrow direction for this button
    });

    // When an accordion item is hidden (collapsed), update button state
    accordion.addEventListener('hidden.bs.collapse', function () {
        updateAccordionToggleButton(toggleButton, accordions); // Update "Expand All" button
    });
});
